import { useMemo } from 'react';
import { useQuery } from 'react-query';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { getAccessLogsAPI } from './api';
import { mapDataToClient } from './mapData';

export const GET_ACCESS_LOGS = 'getAccessLogs';

const LIMIT = 10;

export function useGetAccessLogs(page = 1, category, user, credentials, zone, from, to) {
  const tenantId = getTenantIDBasedOnURL();
  const offset = LIMIT * (page - 1);

  const { data, isLoading, isFetching, isError } = useQuery([
    GET_ACCESS_LOGS, tenantId, offset, category, user, credentials, zone, from, to,
  ], () => getAccessLogsAPI({ offset, limit: LIMIT + 1, category, user, credentials, zone, from, to }), {
    refetchInterval: 60000,
  });

  const hasMore = !!(data && data.accessLogs && data.accessLogs.length > LIMIT);

  const accessLogs = useMemo(() => {
    if (!data || !data.accessLogs) return [];
    const items = hasMore ? data.accessLogs.slice(0, LIMIT) : data.accessLogs;
    return mapDataToClient(items) || [];
  }, [data, hasMore]);

  return {
    accessLogs,
    isLoading,
    isFetching,
    isError,
  };
}

